module.exports = __webpack_public_path__ + "img/test-2.519d8eb3.svg";